module.exports = __webpack_public_path__ + "static/media/ic_apple_white.d5e4a349.svg";